<template>
    <div class="payment-screen">
        <div class="pm-topbar">
            <back-button />
        </div>

        <div class="pm-inner">
            <div class="pm-title">{{ $t('payment.payment_method') }}</div>

            <payment-card v-if="paymentSet" :owner-id="currentUser && currentUser.uid || null"
                :payment-method="account.stripeAccount.paymentMethod"/>

            <card-creator v-else @success="onCreateSuccess" @error="onCreateError"/>

            <subscription-status />
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import CardCreator from "../../components/common/payment/CardCreator";
import PaymentCard from "../../components/common/payment/PaymentCard";
import SubscriptionStatus from "@/components/student/SubscriptionStatus";
import BackButton from "@/components/common/BackButton";

export default {
    name: "PaymentMethod",
    components: {BackButton, SubscriptionStatus, PaymentCard, CardCreator},
    props: {
        redirectToRoute: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            error: '',
            loading: false
        }
    },
    computed: {
        ...mapState(['account', 'currentUser']),
        paymentSet() {
            const vm = this
            return !!vm.account && !!vm.account.stripeAccount && !!vm.account.stripeAccount.paymentMethod
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        async onCreateSuccess() {
            const vm = this

            if (vm.account) {
                await vm.bindUserAccount(vm.currentUser)
            }

            if (vm.redirectToRoute) await vm.$router.push(vm.redirectToRoute)
        },
        onCreateError(error) {
            const vm = this
            console.log('error', error)
        }
    },
}
</script>

<style scoped>
.payment-screen {
    max-width: 520px;
    margin: 0 auto;
}

.pm-topbar {
    margin-bottom: 12px;
}

.pm-inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.pm-title {
    font-size: 12px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.06em;
}
</style>